export const ALX_AFRICA_DOMAIN = 'alxafrica.com';
export const ALX_AFRICA_STAGING_DOMAIN = 'alx-staging.com';

// Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character:
export const passwordValidationRegex =
  /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*\W)(?!.* ).{8,}$/;
export const nameRegex =
  '^[a-zA-Z\u00C0-\u017F\u0180-\u024F\u0250-\u02AF\u1E00-\u1EFF\u0027\u002D]+$';
export const maxLengthInput = 32;
